<template>
  <nav class="menu-container">

    <RouterLink
      :exact="item.exact"
      v-for="item in items"
      :key="item.link"
      :to="{ name: item.name }"
      active-class="selected"
      exact-active-class=""
    >
      <div class="icon">
        <Icon :type="item.icon" />
      </div>
      <span>{{ item.title }}</span>
    </RouterLink>
    百鸽笼站<br>
站点介绍<br>
百鸽笼站为远期小交路折返站位于龙岗区企岭北路东侧，在规划翔鸽路、创富南路、荣华路（均未实施）的交口，沿规划的翔鸽路南北布置。车站北侧为万科红住宅区及办公楼、沃尔玛，南端为信义荔山公园、信义金御半山，西侧为布吉镇经济发展有限公司、百合地产，东侧是金星玻璃有限公司、深特变工业区、布吉华润万象汇、该站为地下站。<br><br>
运营时刻表(工作日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
赤湾	06:06	23:13	5号线	3分钟	5分25秒<br>
黄贝岭	06:14	00:09	5号线	3分钟	5分25秒<br><br>
运营时刻表(休息日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
赤湾	06:18	23:13	5号线	4分钟	6分钟<br>
黄贝岭	06:17	00:08	5号线	4分钟	6分钟<br><br>
运营时刻表(节假日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
赤湾	06:18	00:13	5号线	4分钟	6分钟<br>
黄贝岭	06:17	01:08	5号线	4分钟	6分钟<br><br>

站点出口信息<br><br>
A出入口:<br>
翔鸽路西侧、万科·红、锦龙路、罗岗医院<br><br>
B出入口:<br>
罗岗居委会、百鸽笼公交接驳站、信义荔山公馆、信义荔山公园、罗岗路南侧<br><br>
C出入口:<br>
创富南路南侧、佳兆业可园<br><br>
D出入口:<br>
木棉湾小学、翔鸽路东侧<br><br>
公交换乘信息<br><br>
B出入口:<br>
公交站名： 百鸽笼地铁站<br>
80、822、B741、M281<br><br>
D出入口:<br>
公交站名： 百鸽笼公交接驳站<br>
80、82<br>
</nav>
</template>

<script>
// import Icon from "@/components/Icon";
export default {
  components: {
    // Icon,
  },
  data() {
    return {
      items: [
        {
          name: "wuhaoxian",
          title: "5号线",
          // icon: "chat",
          exact: true,
        },
      ],
    };
  },
};
</script>

<style scoped lang="less">
@import "~@/styles/var.less";
.menu-container {
  color: @words;
  margin: 24px 0;
  a {
    &.selected {
      background: darken(@words, 3%);
    }
    padding: 0 50px;
    display: block;
    display: flex;
    align-items: center;
    height: 45px;
    // .icon {
    //   width: 24px;
    // }
    &:hover {
      color: rgb(50, 95, 227);
    }
  }
}
</style>


